import { mapGetters, mapMutations } from "vuex";
import { accessContent } from '@/student/api/Content.js'


export default
{
  data(){
    return {
      count_started: false,
      updateTimeId: null,
    }
  },
  watch: {
    content: {
      handler() {
        
        
        if(!this.content.finished_at){

          clearInterval(this.updateTimeId);
          
            this.count_started = true;
  
            this.updateTimeId = setInterval(() => {
              
              this.updateContentInfo()
  
              if (this.content.left_seconds <= 0) {
                clearInterval(this.updateTimeId);
              }
            }, 1000);
          }
        
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['module','selectedCycle','accessing_content'])
  },
  mounted(){
    if(!this.accessing_content) {
      accessContent(this.content.id)
    }
  },
  methods: {
    ...mapMutations(['SET_MODULE']),
    updateContentInfo(){
      this.SET_MODULE({
        ...this.module,
        contents: this.module.contents.map(c => {
          if(c.id == this.content.id){
            
            c.left_seconds = 0

            // if(c.left_seconds <= 0 || this.selectedCycle.is_finished || this.isInDevelop) {
            if(c.left_seconds <= 0 || this.selectedCycle.is_finished) {
              c.released_to_finish = true
              c.left_seconds = 0
            }
          }
          return c
        })
      })
    }
  },
  destroyed(){
    clearInterval(this.updateTimeId)
  }
}
